import { Input } from '@ui-components/neo.tax';

import { ValueInputType } from './types';

// eslint-disable-next-line react/prop-types -- Lint bug: They're specified.
export const StringValueInput: ValueInputType = ({ onChange, value }): React.ReactElement => (
  <Input
    value={value ?? ''}
    onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
      onChange(e.target.value);
    }}
  />
);
